"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns true if `a` is an Array.
 *
 * @example
 * ```ts
 * isArray([1, 2, 3]); // true
 * isArray(2); // false
 * ```
 */
var isArray = function (input) { return Array.isArray(input); };
exports.default = isArray;
//# sourceMappingURL=isArray.js.map